import { RouterView, type RouterOptions } from "vue-router";
import EntityAudits from "@/components/EntityAudits.vue";
import { EntityNotes } from "@modernary/mui/components/note";
// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  disposalReports: "DisposalReport.DisposalReports",
  list: "DisposalReport.DisposalReportList",
  new: "DisposalReport.DisposalReportNew",
  newSchedule: "DisposalReport.DisposalReportNewSchedule",
  newSelect: "DisposalReport.DisposalReportNewSelect",
  base: "DisposalReport.DisposalReportBase",
  view: "DisposalReport.DisposalReportView",
  edit: "DisposalReport.DisposalReportEdit",
  updateStatus: "DisposalReport.DisposalReportUpdateStatus",
  notes: "DisposalReport.DisposalReportNotes",
  noteEdit: "DisposalReport.DisposalReportNoteEdit",
  noteNew: "DisposalReport.DisposalReportNoteNew",
  audit: "DisposalReport.DisposalReportAudit",
};

export { names as disposalReportRouteNames };

const disposalReportRoutes: RouterOptions["routes"] = [
  {
    path: "/disposalReports",
    name: names.disposalReports,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Disposal Reports",
          lookupGroups: [
            "PermitType",
            "DisposalReportFrequency",
            "ReportPeriod",
            "DisposalReportStatus",
            "ReportFrequency",
          ],
        },
        component: () => import("@/views/disposalReport/DisposalReportList.vue"),
      },
      {
        path: "new/:permitId(\\d+)?",
        component: () => import("@/views/disposalReport/DisposalReportBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: ":reportScheduleId(\\d+)?",
            name: names.new,
            meta: { title: "Create Disposal Report", isNew: true },
            component: () => import("@/views/disposalReport/DisposalReportEdit.vue"),
          },
          {
            path: "schedule/:previousReportId(\\d+)?/:reportScheduleId(\\d+)?",
            name: names.newSchedule,
            meta: { title: "Schedule Next Disposal Report", isSchedule: true, isForm: true },
            component: () => import("@/views/disposalReport/DisposalReportEdit.vue"),
          },
          {
            path: "select",
            name: names.newSelect,
            meta: { title: "New Disposal Report", isNew: true },
            component: () => import("@/views/disposalReport/DisposalReportSelect.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/disposalReport/DisposalReportBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Disposal Report View" },
            component: () => import("@/views/disposalReport/DisposalReportView.vue"),
          },
          {
            path: "edit", // Also accepts a query param - start = true or approve = true, extend = true
            name: names.edit,
            meta: { title: "Disposal Report Edit", isForm: true },
            component: () => import("@/views/disposalReport/DisposalReportEdit.vue"),
          },
          {
            path: "updateStatus", // Also accepts a query param - approve = true
            name: names.updateStatus,
            meta: { title: "Update Disposal Report Status", isForm: true },
            component: () => import("@/views/disposalReport/DisposalReportStatusUpdate.vue"),
          },
          {
            path: "notes",
            name: names.notes,
            meta: { title: "Disposal Report Internal Notes" },
            component: {
              render: () => <EntityNotes idField="reportId" routeNamePrefix="DisposalReport.DisposalReportNote" />,
            },
          },
          {
            path: "notes/:annotationId(\\d+)",
            name: names.noteEdit,
            meta: { title: "Edit Disposal Report Internal Note", isForm: true },
            component: () => import("@/views/disposalReport/DisposalReportNote.vue"),
          },
          {
            path: "notes/new",
            name: names.noteNew,
            meta: { title: "Create Disposal Report Internal Note", isForm: true },
            component: () => import("@/views/disposalReport/DisposalReportNote.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Disposal Report Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="DisposalReport" />,
            },
          },
        ],
      },
    ],
  },
];
export default disposalReportRoutes;
